import Model from "@/lib/model/model";
import request from "@/lib/request/request";

import V from "@/store/vuex-store";

export class TL extends Model {
  env = 0; // 模板场景
  type = 0; // 模板类型
  templateId = 0; // 模板id
}

export class Template extends Model {
  companyId = 0; // 公司id
  templateId = 0;
  examType = ""; // 面试类型 aibuilder/aiworker
  env = 1; // 模板场景 1邀请 2通过 3淘汰
  type = 0; // 模板类型 1短信 2邮件 4待定 5提醒
  name = ""; // 模板名称
  isDefault = 0; // 是否是公司级别默认模板
  isClose = 0; // 是否关闭发送
  mobileContent = ""; // 短信内容
  emailContentHtml = ""; // 邮件内容
  emailContentTextOnly = ""; //邮件内容 纯文本版
  emailName = ""; // 邮件发件人
  emailSubject = ""; // 邮件主题

  static create(param: Template) {
    return request.post("/aiExam/message/templateCreate", param).then(resp => {
      return resp;
    });
  }
  static get(param: any) {
    return request.post("/aiExam/message/templateGet", param).then(resp => {
      return resp;
    });
  }
  static update(param: any) {
    return request.post("/aiExam/message/templateUpdate", param).then(resp => {
      return resp;
    });
  }
  static del(param: any) {
    return request.post("/aiExam/message/templateDelete", param).then(resp => {
      return resp;
    });
  }
  static getTemplateList(param: any) {
    return request.post("/aiExam/message/templateList", param).then(resp => {
      return resp;
    });
  }

  static getExamTemp(param: any) {
    return request.post("/aiExam/message/examGet", param).then(resp => {
      return resp;
    });
  }
  static setExamTemp(param: any) {
    return request.post("/aiExam/message/examLink", param).then(resp => {
      return resp;
    });
  }
}
export class ExamTemp extends Model {
  examId = 0;
  companyId = 0;
  autoPassMessage = 2;
  autoRefuseMessage = 2;
  noticeMessageHourLimit = 24; //面试提醒通知时间 24/48
  noticeMessageType = 0; // 面试提醒通知是否仅高峰时间发送
  autoWaitMessage = null; //面试待定通知是否自动发送
  autoNoticeMessage = 2; // 是否开启面试提醒通知
  templateList: Template[] = [new Template()];
}
